import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _property from 'lodash/property';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _trim from 'lodash/trim';
import { EMPTY_OBJECT, NO_DATA } from '../app.constants';
export var ID_FIELD_NAME = 'id';
export var USER_ID_FIELD_NAME = 'userID';
export var DEALER_AND_ROLES_FIELD_NAME = 'dealerAndRoles';
export var CURRENTY_USER_ROLE_ID = 'roleId';
export var EMPLOYEE_ID_FIELD_NAME = 'employeeId';
export var EMPLOYEE_DISPLAY_NUMBER_FIELD_NAME = 'employeeDisplayNumber';
export var USER_EMAIL_FIELD_NAME = 'email';
export var USER_PROFILE_PICTURE_FIELD_NAME = 'profilePicture';
export var USER_TYPE_FIELD_NAME = 'type';
export var USER_MANAGER_FIELD_NAME = 'managerId';
export var USER_ACTIVE_FIELD_NAME = 'active';
export var USER_IS_ACTIVE_FIELD_NAME = 'isActive';
export var USER_JOB_TITLE_FIELD_NAME = 'jobTitle';
export var DISPLAY_NAME_FIELD_NAME = 'displayName';
export var DEALER_OEM_SITES_FIELD_NAME = 'dealerOemSites';
export var USER_FIRST_NAME_FIELD_NAME = 'fname';
export var USER_LAST_NAME_FIELD_NAME = 'lname';
export var DEALER_ID_FIELD_NAME = 'dealerId';
export var TEK_SITE_ID_FIELD_NAME = 'tekSiteId';
export var EMPLOYEE_DEALER_MAPS = 'employeeDealerMaps';
export var SSO_LOGOUT_URL = 'ssoLogoutURL';
export var CURRENT_USER_PERSONA = 'persona';
export var SSO_ENABLED = 'ssoEnabled';
export var USER_PREFERRED_LOCALE = 'userPreferredLocale';
export var TENANT_NAME_FIELD_NAME = 'tenantName';

var id = _property(ID_FIELD_NAME);

var userName = _property('name');

var position = _property(USER_JOB_TITLE_FIELD_NAME);

var phone = _property('phone');

var tenantId = _property('tenantId');

var dealerId = _property(DEALER_ID_FIELD_NAME);

var tenantName = _property(TENANT_NAME_FIELD_NAME);

var profileImgUrl = _property(USER_PROFILE_PICTURE_FIELD_NAME);

var employeeDisplayNumber = _property(EMPLOYEE_DISPLAY_NUMBER_FIELD_NAME); // deprecated. use tbase > userUtils > getDealerUserEmployeeDetails instead


var fname = _property(USER_FIRST_NAME_FIELD_NAME);

var firstName = _property('firstName');

var lname = _property(USER_LAST_NAME_FIELD_NAME);

var lastName = _property('lastName');

var active = _property(USER_ACTIVE_FIELD_NAME);

var userID = _property(USER_ID_FIELD_NAME);

var employeeDealerMaps = _property('employeeDealerMaps');

var dealerOemSites = _property(DEALER_OEM_SITES_FIELD_NAME);

var tenantUserName = function tenantUserName(user) {
  if (_isEmpty(user)) return NO_DATA;

  var userInfo = _get(user, 'data', EMPTY_OBJECT);

  return name(_objectSpread(_objectSpread({}, user), userInfo));
};

var name = function name() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  if (user.name) return user.name;
  if (user.displayName) return user.displayName;
  if (user.displayValue) return user.displayValue;
  var userFirstName = user.firstName || user.fname || '';
  var userLastName = user.lastName || user.lname || '';
  return _trim("".concat(userFirstName, " ").concat(userLastName));
};

var isActive = function isActive(user) {
  var sanitizedUser = user || EMPTY_OBJECT;
  return sanitizedUser.isActive || sanitizedUser.active;
};

var userId = function userId(user) {
  return _get(user, USER_ID_FIELD_NAME) || id(user);
};

var email = _property(USER_EMAIL_FIELD_NAME);

var displayName = _property(DISPLAY_NAME_FIELD_NAME);

var managerId = _property(USER_MANAGER_FIELD_NAME);

var type = _property(USER_TYPE_FIELD_NAME);

var firstTimePWDReset = _property('firstTimePWDReset');

var dealerAndRoles = _property(DEALER_AND_ROLES_FIELD_NAME);

var roleId = _property(CURRENTY_USER_ROLE_ID);

var homeDealerId = _property('homeDealerId');

var employeeId = _property(EMPLOYEE_ID_FIELD_NAME); // deprecated. use tbase > userUtils > getDealerUserEmployeeDetails instead


var personalInfo = _property('personalInfo');

var secondaryRoleIds = _property('secondaryRoleIds');

var language = _property('language'); // temporary, need to check key with backend


var ssoLogoutUrl = _property(SSO_LOGOUT_URL);

var persona = _property(CURRENT_USER_PERSONA);

var ssoEnabled = _property(SSO_ENABLED);

var READER = {
  id: id,
  dealerId: dealerId,
  dealerAndRoles: dealerAndRoles,
  email: email,
  employeeDisplayNumber: employeeDisplayNumber,
  name: name,
  position: position,
  profileImgUrl: profileImgUrl,
  userId: userId,
  displayName: displayName,
  managerId: managerId,
  phone: phone,
  type: type,
  tenantId: tenantId,
  tenantName: tenantName,
  isActive: isActive,
  roleId: roleId,
  firstTimePWDReset: firstTimePWDReset,
  userName: userName,
  fname: fname,
  firstName: firstName,
  lname: lname,
  lastName: lastName,
  tenantUserName: tenantUserName,
  homeDealerId: homeDealerId,
  employeeId: employeeId,
  active: active,
  userID: userID,
  personalInfo: personalInfo,
  employeeDealerMaps: employeeDealerMaps,
  secondaryRoleIds: secondaryRoleIds,
  dealerOemSites: dealerOemSites,
  language: language,
  ssoLogoutUrl: ssoLogoutUrl,
  persona: persona,
  ssoEnabled: ssoEnabled
};
export default READER;